
export default {
  name: 'CustomerTypeSelector',
  data() {
    return { 
      isBusiness: false
    }
  },
  computed: {
    order() { return this.$store.getters.order }
  },
  watch: {
    order() { 
      this.isBusiness = this.order.requires_billing_info
    }
  },
  mounted() {
    this.handleCustomerType(this.order.requires_billing_info || false)
  },
  methods: {
    async handleCustomerType(business){
      this.isBusiness = business
      await this.$store.dispatch('setBusiness', business)
    }
  }
}
